import { Injectable } from "@angular/core";
import { HttpService, HttpServiceBaseCRUD, GetPagedBody, Lookup } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class EventTypesService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "eventtypes/";
  }

  add(body: Lookup) {
    return this.post<Lookup>({ APIName: "add", body, showAlert: true });
  }

  update(body: Lookup) {
    return this.put<Lookup>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete<boolean>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<Lookup>({ APIName: `get/${id}` });
  }

  getPaged(body: GetPagedBody<Lookup>) {
    return this.getPagedRequest<Lookup[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<Lookup[]>({ APIName: "getall" });
  }
}
